module.exports = __webpack_public_path__ + "img/Einsatzabschnittsleiter.183d014c.svg";